import { useCollectionItem, useCollectionItems } from '@rocketlane/state-db';
import { phaseCollection } from './phase-collection';
/**
 * Reactive single-phase read from the collection (O(1) per-id subscription).
 * Returns `undefined` until a detail/list/board fetch has populated this id.
 */ export const usePhase = (phaseId)=>useCollectionItem(phaseCollection, phaseId);
/**
 * Reactive phase list joined LIVE against the collection, in the exact order
 * of `phaseIds`. Deliberately takes the order as an argument rather than
 * deriving it internally: the collection has no ordering concept of its own,
 * and `project.projectPhases` array order is the source of truth for phase
 * display order (gantt rows, phase dropdowns) — callers pass
 * `project.projectPhases.map(p => p.projectPhaseId)` and get back the SAME
 * order with live (collection-backed) data. Mirrors `useCollectionItems`'s use
 * in `collections/plan-board/hooks.ts` for lane task ids.
 */ export const usePhasesInOrder = (phaseIds)=>useCollectionItems(phaseCollection, phaseIds);
